module.exports = __webpack_public_path__ + "static/media/logo.ead84804.png";